import { GtmEvent } from '../../enum/gtm-event';
import { GtmAction } from '../gtm-action';
import { GtmVariableKey } from '../gtm-variable-key';

export type HelpCenterClickedGtmActionPayload = {
    [GtmVariableKey.position]: string;
};

export class HelpCenterClickedGtmAction implements GtmAction {
    event = GtmEvent.help_center_clicked;
    constructor(public payload: HelpCenterClickedGtmActionPayload) {}
}
